// Taken from Dawn theme - 'assets/global.js'

const getProductId = () => document.querySelector('#AddToCartForm #productSelect')?.dataset.productid;

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.ObserverLite = this.ObserverLite || new ObserverLite();
  }

  subscribe(callback) {
    return this.ObserverLite.subscribe(callback);
  }

  next() {
    this.ObserverLite.next();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateInventoryQty();
    //this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.afterpay();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateSubscriptions();
      this.renderProductInfo();
      this.updateShareUrl();
      this.next();
    }
  }

  afterpay(opts = {}) {
    const priceUpdated = opts.fromRenderProductInfo === true;

    const runPriceV2Logic = () => {
      document.querySelector('square-placement').style.opacity = 0;
      const pricev2 = document.querySelector('span.price-v2-pdp');
      if (!pricev2) return;

      const price = pricev2.innerText.slice(1);
      const parent = squarePlacement.parentNode;
      const clone = squarePlacement.cloneNode(true);

      
      parent.appendChild(clone);
      clone.classList.add('square-placement-clone', 'active');
      clone.classList.remove('hide');
      clone.dataset.amount = price;
      clone.style.opacity = 1;

      document.querySelector('square-placement').classList.add('hide');
      document.querySelector('square-placement').classList.remove('active');
    };

    document.querySelectorAll('.square-placement-clone').forEach((clone) => clone.remove());

    const squarePlacement = document.querySelector('square-placement');

    if (!squarePlacement) return;

    const subscriptionOptions = document.querySelector('[data-template-legacy-radio]');
    if (subscriptionOptions) {
      squarePlacement.classList.remove('hide');
      squarePlacement.classList.add('active');

      setTimeout(() => {
        const activeOption = document.querySelector('.rc-option--active .rc-option__price');

        if (activeOption) {
          const price = activeOption.innerText.slice(1);
          const parent = squarePlacement.parentNode;
          const clone = squarePlacement.cloneNode(true);

          parent.appendChild(clone);
          document.querySelector('square-placement').classList.add('hide');
          document.querySelector('square-placement').classList.remove('active');
          clone.classList.add('square-placement-clone', 'active');
          clone.dataset.amount = price;
        }
      }, 50);
    } else {
      squarePlacement.classList.remove('hide');
      squarePlacement.classList.add('active');

      if (priceUpdated) {
        runPriceV2Logic();
      } else {
        setTimeout(runPriceV2Logic, 50);
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  // Update form inventory qty so it can be passed as a line_item prop
  updateInventoryQty() {
    const form = document.querySelector('.js-product-form-wrapper form');
    const variantInventoryQty = form.querySelector(`option[value='${this.currentVariant.id}']`)?.getAttribute('data-option-inventory-qty');
    if (variantInventoryQty) {
      const quantityInput = form.querySelector('input[name="quantity"]');
      quantityInput?.setAttribute('data-variant-inventory-qty', variantInventoryQty);
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => this.setActiveMedia(`${this.currentVariant.featured_media.id}`));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  setActiveMedia(mediaId) {
    const productGalleryContainer = document.querySelector('main .product-gallery-container');

    const prevActiveSlide = productGalleryContainer.querySelector('.product-image-carousel__slide.active-slide');
    const newActiveSlide = productGalleryContainer.querySelector(`[data-variant-media-id="${mediaId}"]`);
    const image = productGalleryContainer.querySelector('.active-image img.gallery-main-image');

    if (!prevActiveSlide || !newActiveSlide || !image) return;

    prevActiveSlide.classList.remove('active-slide');
    newActiveSlide.classList.add('active-slide');
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #AddToCartForm, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    if (section.querySelector('.errors.qty-error')) {
      section.querySelector('.errors.qty-error').remove();
    }
    // Dawn connection to product-form element
    // const productForm = section.querySelector('product-form');
    // if (productForm) productForm.handleErrorMessage();
  }

  async renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    // Parse disableAtcData immediately (before async fetch) for instant button state update
    const disableAtcEl = document.getElementById('disable-atc-variants');
    if (disableAtcEl && !this.disableAtcData) {
      try {
        this.disableAtcData = JSON.parse(disableAtcEl.textContent.trim());
      } catch (e) {
        console.error('Failed to parse disable-atc-variants JSON', e);
      }
    }

    // Update button state immediately if disableAtcData is available
    if (this.disableAtcData && this.disableAtcData[this.currentVariant.id] === true) {
      this.toggleAddButton(true, 'Not available for purchase', false, true);
    } else if (this.disableAtcData && this.disableAtcData[this.currentVariant.id] === false) {
      this.toggleAddButton(false, '', false, false);
    }

    const url = `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`;

    const response = await fetch(url);
    const responseText = await response.text();

    // prevent unnecessary ui changes from abandoned selections
    if (this.currentVariant.id !== requestedVariantId) return;

    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(`price-${this.dataset.section}`);
    const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
    const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
    const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
    const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

    const oosPopover = document.getElementById('OutOfStockPopover');
    const oosPopoverSource = html.getElementById('OutOfStockPopover');

    const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
    }
    if (oosPopover && oosPopoverSource) oosPopover.replaceWith(oosPopoverSource.cloneNode(true));

    const price = document.getElementById(`price-${this.dataset.section}`);
    if (price) price.classList.remove('visibility-hidden');

    const addToCartTextSource = html.getElementById('AddToCartText');
    const addToCartTextDestination = document.getElementById('AddToCartText');
    if (addToCartTextSource && addToCartTextDestination) addToCartTextDestination.innerHTML = addToCartTextSource.innerHTML;

    const labelSource = html.querySelector('.f-product-hero__details .label-wrapper');
    const labelDestination = document.querySelector('.f-product-hero__details .label-wrapper');
    if (labelSource && labelDestination) {
      const clonedNode = labelSource.cloneNode(true);
      labelDestination.replaceWith(clonedNode);
    }

    if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

    const addButtonUpdated = html.querySelector(`.ProductSubmitButton-${sectionId}`);

    // Only update button if disableAtcData wasn't already handled above
    if (!this.disableAtcData || (this.disableAtcData[this.currentVariant.id] !== true && this.disableAtcData[this.currentVariant.id] !== false)) {
      this.toggleAddButton(addButtonUpdated ? addButtonUpdated.classList.contains('hide') : true, window.variantStrings.soldOut);
    }

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId,
        html,
        variant: this.currentVariant,
      },
    });

    await window.updateMdpLabelV2?.(String(requestedVariantId), getProductId());

    // if subs are active, price box to contain price of correct subs option (onetime / subsave)
    if (window.rechargeWidgetLoaded) {
      const pricePre = document.querySelector('.rc_container_wrapper .rc-option--active s.rc_widget__price').textContent;
      const priceAct = document.querySelector('.rc_container_wrapper .rc-option--active span.rc_widget__price').textContent;

      const priceBox = document.querySelector('#AddToCart');
      priceBox.querySelector('s.price-v2__pre-pdp') && (priceBox.querySelector('s.price-v2__pre-pdp').textContent = pricePre);
      priceBox.querySelector('span.price-v2__actual-pdp').textContent = priceAct;
    }

    this.afterpay({ fromRenderProductInfo: true });

    // Update LL points
    const priceActual = document.querySelector('#AddToCart .price-v2__actual-pdp')?.textContent || false;
    const loyaltyHint = document.querySelector('.js-loyalty-hint__price');
    const loyaltyHintParent = loyaltyHint?.closest('product-loyalty-points-hint-v2') || false;

    if (!priceActual && loyaltyHint && loyaltyHintParent) {
      loyaltyHintParent.style.display = 'none';
      return;
    }
    if (loyaltyHint) loyaltyHint.innerHTML = priceActual;

    if (loyaltyHintParent) {
      loyaltyHintParent.style.display = 'flex';
    }

    window.loyaltylion.ui && window.loyaltylion.ui.refresh();
  }

  toggleAddButton(disable, text, modifyClass, disableAtc = false) {
    const productForm = document.querySelector(`.product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('.js-product-main-atc');
    const addButtonText = productForm.querySelector('.js-product-main-atc > span');
    const oosButton = productForm.querySelector('.js-out-of-stock-trigger ');
    const disabledAtcButton = productForm.querySelector('.js-disabled-atc-trigger');
    const afterpayButton = productForm.querySelector('square-placement');

    if (!addButton) return;

    if (disable) {
      if (disableAtc === false) {
        oosButton.classList.remove('hide');
      } else {
        disabledAtcButton.classList.remove('hide');
        oosButton.classList.add('hide');
      }

      addButton.setAttribute('disabled', 'disabled');
      addButton.classList.add('hide');

      addButton.setAttribute('onclick', '');
      addButton.setAttribute('name', '');
      addButton.setAttribute('id', '');
      addButton.setAttribute('type', 'button');

      if (afterpayButton) afterpayButton.classList.add('hide');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.setAttribute('onclick', 'GlobalCartMain.addProductFromButton(event)');
      addButton.setAttribute('name', 'add');
      addButton.setAttribute('id', 'AddToCart');
      addButton.setAttribute('type', 'submit');
      addButton.removeAttribute('disabled');
      addButton.classList.remove('hide');
      oosButton.classList.add('hide');
      disabledAtcButton.classList.add('hide');
      if (afterpayButton) afterpayButton.classList.remove('hide');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector(':scope > script[type="application/json"]').textContent);
    return this.variantData;
  }

  async updateSubscriptions() {
    const variantId = this.currentVariant.id;
    const selectedOption = document.querySelector(`#AddToCartForm option[value="${variantId}"]`);
    if (!selectedOption) return;

    // update compare-at pricing
    const variantCompare = selectedOption.getAttribute('data-compare');

    const comparesToUpdate = document.querySelectorAll('s.rc_widget__price.compare-at--onetime, s.rc_widget__price.compare-at--subsave');

    comparesToUpdate.forEach((c) => {
      c.textContent = c.getAttribute('update') === 'true' ? variantCompare : '';
    });

    // Recharge re-renders undiscounted prices for the new variant - wait for that,
    // then reapply the mdp discount.
    if (!window.rechargeWidgetLoaded || !window.applyMdpRcWidgetPricing) return;

    const getRcRoot = () => document.getElementById('AddToCartForm');
    const pricesBefore = window.getRcWidgetPrices(getRcRoot);

    await window.waitForRcWidgetRefresh(getRcRoot, pricesBefore);
    if (this.currentVariant?.id !== variantId) return;

    // Only drop the cached raw prices if the widget actually re-rendered, otherwise
    // its still-discounted text would be read back as the raw price.
    const pricesAfter = window.getRcWidgetPrices(getRcRoot);
    if (pricesAfter?.onetime !== pricesBefore?.onetime || pricesAfter?.subsave !== pricesBefore?.subsave) {
      window.clearMdpRawPriceCache(getRcRoot);
    }

    await window.applyMdpRcWidgetPricing({ getRoot: getRcRoot, productId: getProductId(), variantId });
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      fieldset.querySelectorAll('.variant_label').forEach((variant) => {
        variant.classList.remove('selected');
      });
      checkedRadio.closest('.variant_label').classList.add('selected');
      return checkedRadio.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantRadiosDynamicLabel extends HTMLElement {
  constructor() {
    super();
  }

  handleError(err) {
    if (err) {
      console.log(err);
    }
    this.remove();
  }

  connectedCallback() {
    DomReadyPromise()
      .then(() => {
        let template = this.querySelector(':scope > script');
        if (template) {
          this.settings = JSON.parse(template.textContent);
          template.remove();
          template = null;
        }
        if (!this.settings) {
          this.handleError();
        }

        this.innerHTML = `
        <span class="top-line">
          <span class="top-line-label f-w600 t-ucase"></span>
          <span class="top-line-value f-w600 t-ucase"></span>
        </span>
        <span class="bottom-line"></span>
      `

      this.topLineLabelValue = ''
      this.topLineLabelEl = this.querySelector('.top-line-label')
      this.topLineValueEl = this.querySelector('.top-line-value')
      this.bottomLineEl = this.querySelector('.bottom-line')

      
        this.variantPicker = this.closest('variant-radios');
        this.variantPicker.subscribe(() => {
          this.settings.selected_variant = this.variantPicker.currentVariant;
          this.update();
        });
        this.update();
      })
      .catch((err) => console.log(err));
  }

  update() {
    let current_variant_data = this.settings.variant_metafields.find(({ variant_id }) => variant_id == this.settings.selected_variant.id);
    this.settings.current_variant_data = current_variant_data;
    if (this.topLineLabelEl.innerText === "") {
      this.topLineLabelValue = this.settings?.option_name;
      this.topLineLabelEl.innerText = `${this.topLineLabelValue}: `;
    }
    this.render();
  }

  render() {
    const currentVariantData = this.settings.current_variant_data
    let topLineLabel = this.topLineLabelValue;
    let topLineValue = ''

    if (currentVariantData?.alternate_size_definition) {
      topLineValue = currentVariantData.alternate_size_definition;
      const colonIndex = topLineValue.indexOf(':');

      if (colonIndex !== -1) {
        topLineLabel = topLineValue.substring(0, colonIndex).trim();

        if (topLineValue.length > colonIndex + 1) {
          topLineValue = topLineValue.substring(colonIndex + 1).trim();
        }
      } else {
        topLineLabel = '';
      }
    } else if (currentVariantData?.sf_settings_size) {
      topLineValue = currentVariantData.sf_settings_size;

    } else if (this.settings.sf_product_hero_size) {
      topLineValue = this.settings.sf_product_hero_size;
    }

    const bottomLine = currentVariantData?.estimated_uses || false;

    if(this.topLineLabelValue.trim().toLowerCase() !== topLineLabel.trim().toLowerCase()) {
      this.topLineLabelValue = topLineLabel
      this.topLineLabelEl.innerText = `${this.topLineLabelValue}: `;
    }

    this.topLineLabelEl.style.display = topLineLabel ? 'inline' : 'none';

    this.topLineValueEl.textContent = topLineValue

    this.bottomLineEl.textContent = bottomLine || '';

    this.bottomLineEl.style.display = bottomLine ? 'block' : 'none';

    if(!topLineValue && !bottomLine){
      this.setAttribute('hidden','')
    } else {
      this.removeAttribute('hidden')
    }
  }
}
customElements.define('variant-radios-dynamic-label', VariantRadiosDynamicLabel);
